module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/house-magnifying-glass-fa7b41d951c16a4070fe069528376b3d.svg";